import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { AIAgentModelProvider } from "@graylog/enterprise-api";
import useDebouncedValue from "hooks/useDebouncedValue";
import { emptyAuthFor } from "aiagent/providerAuth";
import generateId from "logic/generateId";
const SETTLE_MS = 750;
const toListArg = (credentials) => {
  var _a;
  return {
    provider: credentials.provider,
    auth: (_a = credentials.auth) != null ? _a : emptyAuthFor(credentials.provider)
  };
};
const useModels = (provider, credentials) => {
  const [settled] = useDebouncedValue(credentials, SETTLE_MS);
  const serialised = settled ? JSON.stringify(settled) : void 0;
  const credentialKey = useMemo(() => serialised ? generateId() : "none", [serialised]);
  const { data, isFetching, error } = useQuery({
    // credentialKey stands in for the credential, which is kept out of the query key on purpose.
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ["ai-model-provider-models", provider, credentialKey],
    queryFn: () => AIAgentModelProvider.listModels(provider, settled ? toListArg(settled) : void 0),
    enabled: Boolean(provider) && Boolean(settled),
    // Retry only genuine server faults; a 4xx means the credentials are refused and will not change until edited.
    retry: (failureCount, err) => {
      var _a;
      return failureCount < 2 && ((_a = err == null ? void 0 : err.status) != null ? _a : 0) >= 500;
    }
  });
  return { data: data != null ? data : [], isFetching, error: error != null ? error : null };
};
export default useModels;
